import { render, staticRenderFns } from "./food.vue?vue&type=template&id=a0a4ae98&scoped=true&"
import script from "./food.vue?vue&type=script&lang=js&"
export * from "./food.vue?vue&type=script&lang=js&"
import style0 from "./food.vue?vue&type=style&index=0&id=a0a4ae98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a4ae98",
  null
  
)

export default component.exports